import { esc } from './icons.js';

/**
 * Modal de formulário reutilizável.
 *
 * O protótipo só tinha o painel lateral de cadastro de empresa; as telas de
 * Tarefas, Pesquisas e Base de Conhecimento eram somente leitura. Este modal
 * é o que permite alimentá-las sem inventar um layout novo para cada uma.
 *
 * Campos aceitos:
 *   { id, label, tipo: 'texto'|'area'|'data'|'select', opcoes, obrigatorio, valor, dica }
 */
export function abrirFormulario({ titulo, subtitulo, campos, rotuloSalvar = 'Salvar', aoSalvar }) {
  const anterior = document.getElementById('modalForm');
  if (anterior) anterior.remove();

  const fundo = document.createElement('div');
  fundo.id = 'modalForm';
  fundo.className = 'modal-fundo';
  fundo.innerHTML = `
    <form class="modal-caixa">
      <div class="modal-topo">
        <div>
          <h2>${esc(titulo)}</h2>
          ${subtitulo ? `<p>${esc(subtitulo)}</p>` : ''}
        </div>
        <button type="button" class="modal-fechar" aria-label="Fechar">&times;</button>
      </div>
      <div class="modal-corpo">
        ${campos.map((c) => htmlCampo(c)).join('')}
      </div>
      <p class="modal-erro" hidden></p>
      <div class="modal-rodape">
        <button type="button" class="btn modal-cancelar">Cancelar</button>
        <button type="submit" class="btn primary modal-salvar">${esc(rotuloSalvar)}</button>
      </div>
    </form>`;

  document.body.appendChild(fundo);

  const fechar = () => fundo.remove();
  fundo.querySelector('.modal-fechar').addEventListener('click', fechar);
  fundo.querySelector('.modal-cancelar').addEventListener('click', fechar);
  fundo.addEventListener('click', (ev) => { if (ev.target === fundo) fechar(); });
  document.addEventListener('keydown', function esc2(ev) {
    if (ev.key === 'Escape') { fechar(); document.removeEventListener('keydown', esc2); }
  });

  fundo.querySelector('form').addEventListener('submit', async (ev) => {
    ev.preventDefault();
    const erro = fundo.querySelector('.modal-erro');
    const salvar = fundo.querySelector('.modal-salvar');
    erro.hidden = true;

    const valores = {};
    for (const c of campos) {
      const el = fundo.querySelector(`[name="${c.id}"]`);
      valores[c.id] = el.value.trim() || null;
      if (c.obrigatorio && !valores[c.id]) {
        erro.textContent = `Preencha "${c.label}".`;
        erro.hidden = false;
        el.focus();
        return;
      }
    }

    salvar.disabled = true;
    salvar.textContent = 'Salvando…';
    try {
      await aoSalvar(valores);
      fechar();
    } catch (err) {
      erro.textContent = err.message;
      erro.hidden = false;
      salvar.disabled = false;
      salvar.textContent = rotuloSalvar;
    }
  });

  fundo.querySelector('.modal-corpo [name]')?.focus();
}

function htmlCampo(c) {
  const valor = c.valor ?? '';
  const comum = `name="${c.id}" id="campo-${c.id}"`;

  let controle;
  if (c.tipo === 'area') {
    controle = `<textarea class="cad-input" ${comum} rows="4">${esc(valor)}</textarea>`;
  } else if (c.tipo === 'select') {
    controle = `<select class="cad-input" ${comum}>
      ${(c.opcoes || []).map((o) =>
        `<option value="${esc(o.valor)}" ${String(o.valor) === String(valor) ? 'selected' : ''}>${esc(o.rotulo)}</option>`
      ).join('')}
    </select>`;
  } else {
    const tipo = c.tipo === 'data' ? 'date' : 'text';
    controle = `<input class="cad-input" type="${tipo}" ${comum} value="${esc(valor)}">`;
  }

  return `
    <div class="modal-campo">
      <label for="campo-${c.id}">${esc(c.label)}${c.obrigatorio ? ' *' : ''}</label>
      ${controle}
      ${c.dica ? `<p class="modal-dica">${esc(c.dica)}</p>` : ''}
    </div>`;
}
